const SI_PREFIXES = [
    { name: 'nano', symbol: 'n', factor: 1e-9 },
    { name: 'micro', symbol: 'μ', factor: 1e-6 },
    { name: 'milli', symbol: 'm', factor: 1e-3 },
    { name: '', symbol: '', factor: 1 },
    { name: 'kilo', symbol: 'k', factor: 1e3 },
    { name: 'mega', symbol: 'M', factor: 1e6 },
];

export function generateUnits(baseUnit) {
    return SI_PREFIXES.map(prefix => ({
        name: prefix.name + baseUnit,
        symbol: prefix.symbol + baseUnit,
        factor: prefix.factor,
    }));
}
